import React, { useState } from 'react';
import './PromoCard.css';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const PromoCard = (props) => {
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const [lineItems, setLineItems] = useState(cart.line_items);
  const item = props.item;
  const cartQuantity = props.inCart[0];

  const updateCart = async (newItem, type) => {
    const itemIndex = lineItems.indexOf(lineItems.find((item) => newItem.product_id === item.product_id));
    props.updateCart(newItem, type, itemIndex);
  };

  const cutString = (title) => {
    const cutChar = 30;
    if (title.length >= cutChar) {
      const shortTitle = title.slice(0, cutChar) + "...";
      return shortTitle
    } else {
      return title;
    }
  }

  return (
    <div
      className="CardContent"
    >
      <figure className="Img">
        <img
          src={item.image}
          className="CardMedia"
          alt={item.title}
        />
        {
          cartQuantity ?
            <div className="QuantityOnHover">
              {cartQuantity}
              <span className="QuantityText">in cart</span>
            </div>
            :
            null
        }

        {
          cartQuantity ?
            <div className="QuantityBadge" style={{ backgroundColor: mainColor }}>
              {cartQuantity}
            </div>
            :
            null
        }
        <div className="Overlay">
          <Button
            style={{ minWidth: 20, height: 20, backgroundColor: mainColor, color: '#FFF' }}
            onClick={() => updateCart(item, "add")}>
            <AddIcon style={{ width: 12 }} />
          </Button>
          {
            cartQuantity ?
              <Button
                style={{ minWidth: 20, height: 20, backgroundColor: mainColor, color: '#FFF' }}
                onClick={() => updateCart(item, "remove")}
              >
                <RemoveIcon style={{ width: 12 }} />
              </Button> : <div style={{ width: 20 }}></div>
          }
        </div>
      </figure>
      <figcaption className="ItemCap">
        {cutString(item.product_title)} <br />
        $ {item.price}
      </figcaption>
    </div>
  )
};

export default PromoCard;